import { HistoryEmptyOrError } from 'src/app/components/HistoryErrorState';
import { selectHistoryError } from 'src/features/historyError';
import {
  Box,
  Button,
  makeStyles,
  TextField,
  withStyles,
  SvgIcon,
  InputAdornment
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import Pagination from '@material-ui/lab/Pagination';
import DateTimeReport from 'src/app/components/input/DateTimeReport';
import {
  getBaoCaoHinhAnh,
  resetDataSceen,
  getLicensePlateQc31,
  resetListLicense
} from '../../../../features/reportBgtQC31Slice';
import { cameraOptions } from '../../image/ImageListView/constance';
import { downloadReportFile } from '../../../utils/downloadReport';
import { TAT_CA_BIEN_SO, TAT_CA_DON_VI } from '../../../constant/reportFilters';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#F5FAFF',
    color: '#0C1132',
    border: '1px solid #E5E5E8'
  },
  body: {
    fontSize: '14px',
    border: '1px solid #E5E5E8',
    color: '#0C1132'
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'white'
    }
  }
}))(TableRow);

const addressCache = {};

/**
 * Ô "Ảnh tĩnh hoặc link ảnh": hiện ảnh thu nhỏ, bấm vào mở tab mới xem ảnh gốc.
 *
 * Vẫn bọc trong thẻ <a target="_blank"> như trước, nên thao tác của người dùng
 * không đổi — kể cả chuột giữa, Ctrl+click hay chuột phải "mở tab mới".
 *
 * Ảnh lấy từ storage qua liên kết có hạn dùng. Hỏng liên kết là chuyện thường,
 * nên khi ảnh không tải được thì rơi về hiện đường dẫn dạng chữ như bản cũ —
 * người dùng vẫn bấm được để thử mở, thay vì nhìn một ô trống.
 */
const AnhChupCell = React.memo(({ url }) => {
  const [khongTaiDuoc, setKhongTaiDuoc] = useState(false);

  useEffect(() => {
    setKhongTaiDuoc(false);
  }, [url]);

  if (!url) return '--';

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" title={url}>
      {khongTaiDuoc ? (
        url
      ) : (
        <img
          src={url}
          alt="Ảnh chụp từ thiết bị"
          loading="lazy"
          onError={() => setKhongTaiDuoc(true)}
          style={{
            display: 'block',
            width: '160px',
            height: '90px',
            objectFit: 'cover',
            border: '1px solid #E5E5E8',
            borderRadius: '4px',
            cursor: 'pointer',
            background: '#F5FAFF'
          }}
        />
      )}
    </a>
  );
});

const LocationCell = React.memo(({ location, lat, lng }) => {
  const [address, setAddress] = useState(location && location !== '--' ? location : '--');

  useEffect(() => {
    if (location && location !== '--') {
      setAddress(location);
      return;
    }

    const latVal = parseFloat(lat);
    const lngVal = parseFloat(lng);
    const hasCoords = !isNaN(latVal) && !isNaN(lngVal) && latVal !== 0 && lngVal !== 0;

    if (!hasCoords) {
      setAddress('--');
      return;
    }

    const cacheKey = `${latVal.toFixed(6)},${lngVal.toFixed(6)}`;
    if (addressCache[cacheKey]) {
      if (addressCache[cacheKey] instanceof Promise) {
        addressCache[cacheKey].then(addr => setAddress(addr));
      } else {
        setAddress(addressCache[cacheKey]);
      }
      return;
    }

    const fetchAddress = async () => {
      try {
        const response = await axios.get(
          `https://map.vgps.vn/reverse?lat=${latVal}&lon=${lngVal}&format=json`
        );
        const data = response.data;
        let displayName = (data?.display_name || '').trim();
        if (displayName) {
          const postcode = data?.address?.postcode || '';
          if (postcode) {
            displayName = displayName.replaceAll(`, ${postcode}`, '');
          }
          displayName = displayName.trim();
        } else {
          displayName = '--';
        }
        addressCache[cacheKey] = displayName;
        setAddress(displayName);
        return displayName;
      } catch (error) {
        console.error('Failed to reverse geocode:', error);
        setAddress('--');
        return '--';
      }
    };

    addressCache[cacheKey] = fetchAddress();
  }, [location, lat, lng]);

  return <span>{address}</span>;
});

const BaoCaoHinhAnh = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const historyError = useSelector(
    selectHistoryError('reportSlice', 'getBaoCaoHinhAnh')
  );
  const dataBaoCaoHinhAnh = useSelector(
    state => state.reportSlice.dataBaoCaoHinhAnh
  );
  const isLoading = useSelector(state => state.reportSlice.isLoading);

  const [nowPage, setNowPage] = useState({
    page: 1
  });

  const [pages, setPages] = useState(0);
  const [agencyError, setAgencyError] = useState(false);

  const [searchObject, setSearchObject] = useState({
    licensePlate: '',
    agencyId: 0,
    firstTime: moment().set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    }),
    lastTime: moment().set({
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999
    }),
    camera: 'Tất cả camera',
    page: 1,
    pageSize: 30
  });

  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const licensePlateQc = useSelector(state => state.reportSlice.licensePlateQc);
  const listUserQC31 = useSelector(state => state.reportSlice.listUserQC31);
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const userId = useSelector(state => state.authSlice.userId);
  const driverId = useSelector(state => state.authSlice.driverId);

  useEffect(() => {
    if (dataBaoCaoHinhAnh && dataBaoCaoHinhAnh.total > 0 && nowPage.page == 1) {
      let currentSearchObject = { ...searchObject };
      var total = dataBaoCaoHinhAnh.total;

      var phanduong = Math.floor(total / currentSearchObject.pageSize);
      var phandu = total % currentSearchObject.pageSize;
      var newPages;

      if (phandu > 0) {
        newPages = phanduong + 1;
      } else {
        newPages = phanduong;
      }

      setPages(newPages);
    } else if (nowPage.page === 1) {
      setPages(0);
    }
  }, [dataBaoCaoHinhAnh]);

  useEffect(() => {
    return () => {
      dispatch(resetDataSceen())
    }
  }, []);

  // Tài khoản không phải quản trị chỉ xem được đơn vị của chính mình — ô chọn đơn
  // vị của họ luôn đúng một dòng. Điền sẵn để bấm Tìm kiếm được ngay, thay vì
  // vướng ở lời nhắc "chưa chọn đơn vị" mà không có gì khác để chọn.
  useEffect(() => {
    if (!isAdmin && dataLogin?.id && !searchObject.agencyId) {
      setSearchObject(prev => ({ ...prev, agencyId: dataLogin.id }));
    }
  }, [isAdmin, dataLogin, searchObject.agencyId]);

  const handleLicenseFocus = () => {
    if (isAdmin && (searchObject.agencyId === undefined || searchObject.agencyId === 0)) {
      setAgencyError(true);
    } else {
      setAgencyError(false);
    }
  };

  const changeSearchCondition = (name, value) => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject[name] = value;
    if (name === 'agencyId') {
      currentSearchObject.agencyId = value?.id || 0;
      currentSearchObject.licensePlate = '';
      if (value?.id) {
        dispatch(getLicensePlateQc31({ id: value.id, business_number: 0 }));
      }
    }
    setSearchObject(currentSearchObject);
  };

  const changeDateCondition = (name, value) => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject[name] = value;
    setSearchObject(currentSearchObject);
  };

  const handleClearAgency = () => {
    setSearchObject({
      ...searchObject,
      agencyId: 0,
      licensePlate: ''
    });
    dispatch(resetListLicense());
  };

  // Chưa chọn đơn vị thì DỪNG, không bịa id.
  //
  // Trước đây chỗ này thay bằng 123456789 — một id không có thật. Máy chủ vẫn trả
  // HTTP 200 kèm mảng rỗng, nên màn hình hiện "Không có dữ liệu" y hệt khi đơn vị
  // đó thật sự không có ảnh. Người dùng không phân biệt được "chưa chọn" với
  // "không có", còn lập trình viên mất dấu vì chẳng có lỗi nào được ghi lại.
  const buildQuery = () => {
    if (!searchObject.agencyId) {
      setAgencyError(true);
      return null;
    }
    setAgencyError(false);
    return {
      ...searchObject,
      firstTime: searchObject.firstTime ? moment(searchObject.firstTime).unix() : null,
      lastTime: searchObject.lastTime ? moment(searchObject.lastTime).unix() : null
    };
  };

  const searchFunction = () => {
    const query = buildQuery();
    if (!query) return;
    setNowPage({ ...nowPage, page: 1 });
    dispatch(getBaoCaoHinhAnh({ ...query, page: 1 }));
  };

  const handleChange = (e, value) => {
    const query = buildQuery();
    if (!query) return;
    setNowPage({ ...nowPage, page: value });
    dispatch(getBaoCaoHinhAnh({ ...query, page: value }));
  };

  const downloadFile = () => {
    let currentSearchObject = { ...searchObject };

    // Chưa chọn đơn vị thì DỪNG — không bịa id, không tải file rỗng.
    // Máy chủ trả HTTP 200 kèm dữ liệu rỗng cho một đơn vị không có thật, nên
    // người dùng nhận được file Excel trông như thật mà không có gì bên trong,
    // và không phân biệt được "chưa chọn" với "đơn vị không có dữ liệu".
    if (!currentSearchObject.agencyId) {
      setAgencyError(true);
      return;
    }
    setAgencyError(false);

    var urlBase = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${currentSearchObject.agencyId}/image/excel?`;

    if (currentSearchObject.firstTime) {
      urlBase =
        urlBase + 'firstTime=' + moment(currentSearchObject.firstTime).unix();
    }

    if (currentSearchObject.lastTime) {
      urlBase =
        urlBase + '&lastTime=' + moment(currentSearchObject.lastTime).unix();
    }

    if (currentSearchObject.licensePlate) {
      urlBase = urlBase + '&licensePlate=' + currentSearchObject.licensePlate;
    }

    downloadReportFile(urlBase);
  };

  // Mục "Tất cả đơn vị" chỉ có nghĩa với admin: người dùng thường chỉ thấy đúng đơn vị của mình,
  // nên danh sách của họ vốn đã là "tất cả". Sentinel mang chính id của người đang đăng nhập —
  // report API khoanh vùng theo user.id, và với admin thì id đó phân giải ra toàn bộ xe của hệ
  // thống, đúng nghĩa "tất cả đơn vị".
  const listUser = (userId || driverId)
    ? [dataLogin]
    : isAdmin && listUserQC31 && listUserQC31.length
      ? [{ id: dataLogin?.id, full_name: TAT_CA_DON_VI }, ...listUserQC31]
      : listUserQC31;
  //should rename agencyId to userId, but take too much timeee ...
  const endUserValue = listUser?.find((item) => item.id === searchObject.agencyId);
  const selectedCamera =
    cameraOptions.find(option => option.value === searchObject.camera) ||
    cameraOptions[0];

  return (
    <Box className={classes.contentContainer}>
      <div className={classes.titleHeader}>Báo cáo hình ảnh từ TBGNHANLX</div>
      <div className={classes.searchContainer}>
        <div className={classes.searchRow}>
          <div className={classes.searchItem}>
            <div className={classes.label}>Từ ngày</div>
            <div>
              <DateTimeReport
                className={classes.searchComponent}
                dateTime={searchObject.firstTime}
                onChange={e => changeDateCondition('firstTime', e)}
                format="DD/MM/YYYY HH:mm:ss"
                showTime={{ format: 'HH:mm:ss' }}
                width="250px"
              />
            </div>
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Đến ngày</div>
            <div>
              <DateTimeReport
                className={classes.searchComponent}
                dateTime={searchObject.lastTime}
                onChange={e => changeDateCondition('lastTime', e)}
                format="DD/MM/YYYY HH:mm:ss"
                showTime={{ format: 'HH:mm:ss' }}
                width="250px"
              />
            </div>
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Đơn vị kinh doanh vận tải</div>
            <Autocomplete
              freeSolo
              forcePopupIcon
              id="free-solo-2-demo"
              size="small"
              disableClearable
              options={listUser || []}
              getOptionLabel={(option) => option?.full_name}
              value={endUserValue || null}
              onChange={(e, value) => {
                setAgencyError(false);
                changeSearchCondition('agencyId', value);
              }}
              classes={{ option: classes.option }}
              renderInput={params => (
                <TextField
                  {...params}
                  required={true}
                  className={classes.searchComponent}
                  error={agencyError}
                  helperText={agencyError ? 'Vui lòng chọn đơn vị kinh doanh vận tải' : ''}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: '16px',
                      padding: 0,
                      paddingLeft: 8
                    },
                    endAdornment: (
                      <>
                        {Number(searchObject.agencyId) > 0 && isAdmin && (
                          <InputAdornment
                            position="end"
                            style={{ cursor: 'pointer', paddingRight: '38px' }}
                            onClick={handleClearAgency}
                          >
                            <SvgIcon fontSize="small" color="action">
                              <ClearIcon />
                            </SvgIcon>
                          </InputAdornment>
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    )
                  }}
                  variant="outlined"
                //placeholder="Nhập đơn vị kinh doanh"
                />
              )}
            />
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Biển số</div>
            <Autocomplete
              freeSolo
              forcePopupIcon
              id="free-solo-2-demo"
              size="small"
              options={[TAT_CA_BIEN_SO, ...(licensePlateQc || [])]}
              value={searchObject.licensePlate || ''}
              onFocus={handleLicenseFocus}
              onChange={(e, value) =>
                // Biển số rỗng chính là "tất cả xe của đơn vị" ở phía máy chủ, nên mục sentinel
                // chỉ cần quy về rỗng — không thêm nhánh nào ở backend.
                changeSearchCondition(
                  'licensePlate',
                  !value || value === TAT_CA_BIEN_SO ? '' : value
                )
              }
              classes={{ option: classes.option }}
              renderInput={params => (
                <TextField
                  {...params}
                  required={true}
                  className={classes.searchComponent}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: '16px',
                      padding: 0,
                      paddingLeft: 8
                    }
                  }}
                  variant="outlined"
                //placeholder="Nhập biển số"
                />
              )}
            />
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Camera chụp</div>
            <Autocomplete
              id="camera-filter"
              size="small"
              disableClearable
              options={cameraOptions}
              getOptionLabel={option => option.label}
              value={selectedCamera}
              onFocus={handleLicenseFocus}
              onChange={(e, value) =>
                changeSearchCondition(
                  'camera',
                  value ? value.value : 'Tất cả camera'
                )
              }
              classes={{ option: classes.option }}
              renderInput={params => (
                <TextField
                  {...params}
                  required={true}
                  className={classes.searchComponent}
                  placeholder="Tất cả camera"
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: '14px',
                      height: '36px'
                    }
                  }}
                  variant="outlined"
                />
              )}
            />
          </div>

          <div className={classes.btnSearch}>
            {/* Khoá nút khi chưa chọn đơn vị: một lần bấm hụt trả về bảng rỗng
                trông y hệt "đơn vị này không có ảnh". */}
            <Button
              type="button"
              variant="contained"
              className={classes.btnStyle}
              disabled={!searchObject.agencyId}
              onClick={() => searchFunction()}>
              Tìm kiếm
            </Button>
          </div>
        </div>
      </div>

      <div className={classes.actionHead}>
        <img
          alt="print image"
          className={classes.image}
          src="/static/images/print.svg"
        />

        <img
          alt="Excell image"
          className={classes.image}
          src="/static/images/Excel.svg"
          onClick={() => downloadFile()}
        />
      </div>

      <div className={classes.dataTable}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            // size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <TableHead>
              <TableRow>
                <StyledTableCell>TT</StyledTableCell>
                <StyledTableCell align="left">Biển số xe</StyledTableCell>
                <StyledTableCell align="left">Thời gian chụp</StyledTableCell>
                <StyledTableCell align="left">Tọa độ chụp</StyledTableCell>
                <StyledTableCell align="left">Vận tốc</StyledTableCell>
                <StyledTableCell align="left" style={{ minWidth: '140px' }}>Họ tên lái xe</StyledTableCell>
                <StyledTableCell align="left" style={{ minWidth: '120px' }}>Số GPLX</StyledTableCell>
                <StyledTableCell align="left" style={{ minWidth: '100px' }}>Kênh chụp</StyledTableCell>
                <StyledTableCell align="left" style={{ minWidth: '220px' }}>Địa điểm chụp</StyledTableCell>
                <StyledTableCell align="left" style={{ width: '180px', maxWidth: '180px' }}>
                  Ảnh tĩnh hoặc link ảnh
                </StyledTableCell>
                <StyledTableCell align="left">Ghi chú</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataBaoCaoHinhAnh &&
                dataBaoCaoHinhAnh.data &&
                dataBaoCaoHinhAnh.data.length > 0 &&
                dataBaoCaoHinhAnh.data.map((row, index) => {
                  return (
                    <StyledTableRow
                      hover
                      // onClick={(event) => handleClick(event, row.name)}
                      role="checkbox"
                      // aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                    // selected={isItemSelected}
                    >
                      <StyledTableCell>{index + 1}</StyledTableCell>
                      <StyledTableCell>{row.licensePlate}</StyledTableCell>
                      <StyledTableCell>
                        {row.deviceTime
                          ? moment
                            .unix(row.deviceTime)
                            .format('HH:mm:ss DD/MM/YYYY')
                          : ''}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.lat} , {row.lng}
                      </StyledTableCell>
                      <StyledTableCell>{row.speed}</StyledTableCell>
                      <StyledTableCell>{row.driverName}</StyledTableCell>
                      <StyledTableCell>{row.driverLicense}</StyledTableCell>
                      <StyledTableCell>
                        Camera {row.cameraNum ? String(row.cameraNum).charAt(0) : ''}
                      </StyledTableCell>
                      <StyledTableCell>
                        <LocationCell location={row.location} lat={row.lat} lng={row.lng} />
                      </StyledTableCell>
                      {/* Không cắt chữ bằng ellipsis nữa: ô này giờ chứa ảnh, còn nhánh
                          rơi về đường dẫn thì cho xuống dòng để đọc được cả liên kết. */}
                      <StyledTableCell style={{ width: '180px', maxWidth: '180px', wordBreak: 'break-all' }}>
                        <AnhChupCell url={row.url} />
                      </StyledTableCell>

                      <StyledTableCell>{row.note}</StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>

        {!dataBaoCaoHinhAnh ||
          !dataBaoCaoHinhAnh.data ||
          dataBaoCaoHinhAnh.data.length < 1 ? (
          <HistoryEmptyOrError
            error={historyError}
            onRetry={() => dispatch(getBaoCaoHinhAnh(historyError.arg))}
            emptyClassName={classes.bottomTableError}
          />
        ) : null}

        <Backdrop className={classes.backdrop} open={isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <Pagination
          onChange={handleChange}
          className={classes.pagination}
          count={pages}
          page={nowPage.page}
          variant="outlined"
          shape="rounded"
        />
      </div>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    backgroundColor: 'white',
    flexDirection: 'column'
  },
  titleHeader: {
    width: '100%',
    height: '36px',
    color: '#0C1132',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginTop: '16px',
    fontSize: '20px'
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '24px'
    // marginTop: '24px',
    // marginBottom: '24px'
  },
  searchRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: '12px',
    marginBottom: '12px',
    // justifyContent: 'space-between',
    marginRight: '48px'
  },
  searchItem: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 0
  },
  label: {
    marginRight: '20px',
    marginBottom: '4px',
    fontSize: '14px',
    color: '#858C93'
  },
  searchComponent: {
    // marginRight: '6px',
    width: '250px',
    height: '34px',
    '& .MuiOutlinedInput-root': {
      height: '34px'
    }
  },
  timeComponent: {
    marginRight: '4px',
    '& .MuiOutlinedInput-root': {
      height: '30px',
      width: '80px'
    }
  },
  dateComponent: {
    // marginRight: '4px',
    '& .MuiOutlinedInput-root': {
      height: '30px',
      width: '300px'
    }
  },
  btnSearch: {
    width: '180px',
    height: '40px',
    marginLeft: 0,
    alignSelf: 'flex-end'
  },
  btnDownload: {
    width: '100px',
    marginLeft: 'auto'
  },
  dataTable: {
    width: 'calc(100% - 40px)',
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '30px'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
  },
  wrapMenu: {
    marginTop: '30px',
    marginRight: '100px',
    marginLeft: '30px'
  },
  title: {
    color: '#3f51b5',
    cursor: 'pointer'
  },
  menuItem: {
    listStyleType: 'none',
    margin: 0,
    padding: 0
  },
  item: {
    paddingTop: '30px',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '500',

    '&:hover': {
      color: '#3f51b5',
      borderBottom: '1px solid #3f51b5',
      width: 'max-content'
    }
  },
  table: {
    minWidth: 1300
  },
  btnStyle: {
    padding: '10px',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    marginTop: 0,
    marginRight: 0,
    width: '180px',
    height: '40px'
  },

  btnDownloadStyle: {
    padding: '5px',
    color: 'white',
    backgroundColor: 'blue',
    marginTop: '10px'
  },
  pagination: {
    width: '95%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '64px',
    marginTop: '10px'
  },
  actionHead: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '30px',
    backgroundColor: 'white',
    marginBottom: '5px'
  },
  bottomTableError: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.main,
    marginTop: '10px'
  },
  image: {
    marginRight: '10px'
  },
  option: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center'
  }
}));

export default BaoCaoHinhAnh;
